import { render, staticRenderFns } from "./AccountVerify.vue?vue&type=template&id=46801294&scoped=true&"
import script from "./AccountVerify.vue?vue&type=script&lang=js&"
export * from "./AccountVerify.vue?vue&type=script&lang=js&"
import style0 from "./AccountVerify.vue?vue&type=style&index=0&id=46801294&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46801294",
  null
  
)

export default component.exports